import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';

@Component({
  selector: 'app-image-selector',
  templateUrl: './image-selector.component.html',
  styleUrls: ['./image-selector.component.scss']
})
export class ImageSelectorComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() selectedFile: File | string = null;
  @Output() fileSelected: EventEmitter<File> = new EventEmitter<File>();
  @Input() borderRadius: string = null;
  @Input() block: boolean;
  @Input() isCircle: boolean;
  @Input() extensions: string[] = ['jpg', 'jpeg', 'png', 'gif'];
  @ViewChild('input') inputElem: ElementRef<HTMLInputElement>;

  urlForImg = '';
  constructor(
    private alertService: MessageAlertService,
    private utilitiesServices: UtilitiesService
    ) { }

  ngOnInit(): void {
  }

  ngOnChanges(change: SimpleChanges): void {
    if (!change.selectedFile) return;
    if (typeof this.selectedFile === 'string') {
      this.urlForImg = this.selectedFile;
    }
  }

  ngAfterViewInit(): void {
  }

  onOpenSelectFiles(): void {
    if (!this.block) {
      this.inputElem.nativeElement.click();
    }
  }

  onSelectedFile(files: FileList): void {
    const selectedFile = files.item(0);
    if (!selectedFile) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt: ProgressEvent<FileReader>) => {
      if (this.utilitiesServices.validateExtensionImage(selectedFile as File, this.extensions)) {
        this.urlForImg = evt.target.result.toString();
        this.fileSelected.emit(selectedFile as File);
      } else {
        this.urlForImg = typeof this.selectedFile === 'string' ? this.selectedFile : '';
        return;
      }
    };
    reader.onerror = (evt: ProgressEvent<FileReader>) => {
      const errMsg = 'El archivo no se puede leer: ' + evt.target.error.code;
      this.alertService.createMessage('error', errMsg);
    };
    reader.readAsDataURL(selectedFile);
  }
}
